var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm } from '@inertiajs/react';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import { useRoute } from 'ziggy-js';
import JetActionSection from '@/Jetstream/ActionSection';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';
import { Ziggy } from "@/ziggy";
export default function DeleteUserForm() {
    var route = useRoute(Ziggy);
    var _a = useState(false), confirmingUserDeletion = _a[0], setConfirmingUserDeletion = _a[1];
    var form = useForm({
        password: '',
    });
    var passwordRef = useRef(null);
    function confirmUserDeletion() {
        setConfirmingUserDeletion(true);
        setTimeout(function () { var _a; return (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 250);
    }
    function deleteUser() {
        form.delete(route('current-user.destroy'), {
            preserveScroll: true,
            onSuccess: function () { return closeModal(); },
            onError: function () { var _a; return (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus(); },
            onFinish: function () { return form.reset(); },
        });
    }
    function closeModal() {
        setConfirmingUserDeletion(false);
        form.reset();
    }
    return (_jsxs(JetActionSection, __assign({ title: 'Delete account', description: 'Permanently delete your account.' }, { children: [_jsxs("div", __assign({ className: "max-w-xl text-sm text-gray-600" }, { children: ["Once your account is deleted, all of its resources and data will be permanently deleted. Before deleting your account, please download any data or information that you wish to retain.", _jsx("br", {}), _jsx("b", { children: "NB. This includes all Teams where you are the OWNER and all Credits, Certificates, Clients and Vets associated with those Teams." }), _jsx("br", {})] })), _jsx("div", __assign({ className: "mt-5" }, { children: _jsx(JetDangerButton, __assign({ onClick: confirmUserDeletion }, { children: "Delete account" })) })), _jsxs(JetDialogModal, __assign({ isOpen: confirmingUserDeletion, onClose: closeModal }, { children: [_jsxs(JetDialogModal.Content, __assign({ title: 'Delete Account' }, { children: ["Are you sure you want to delete your account? Once your account is deleted, all of its resources and data will be permanently deleted. Please enter your password to confirm you would like to permanently delete your account.", _jsxs("div", __assign({ className: "mt-4" }, { children: [_jsx(JetInput, { type: "password", className: "mt-1 block w-3/4", placeholder: "Password", value: form.data.password, onChange: function (e) { return form.setData('password', e.currentTarget.value); } }), _jsx(JetInputError, { message: form.errors.password, className: "mt-2" })] }))] })), _jsxs(JetDialogModal.Footer, { children: [_jsx(JetSecondaryButton, __assign({ onClick: closeModal }, { children: "Cancel" })), _jsx(JetDangerButton, __assign({ onClick: deleteUser, className: classNames('ml-2', { 'opacity-25': form.processing }), disabled: form.processing }, { children: "Delete account" }))] })] }))] })));
}
